import React, { Component } from "react";
import Container from "react-bootstrap/Container";
import Alert from "react-bootstrap/Alert";
import { withRouter } from "../withRouter";
import {
  getEventByUrl,
  getEventColors,
  getVoterByLink,
  authVoter,
} from "../api";
import Spinner from "react-bootstrap/Spinner";
import { withTheme } from "../withTheme";
import VoterNavBar from "./VoterNavBar.js";
import { BASE_URL } from "../config";
import LoadingButton from "./LoadingButton";

class VoterIntro extends Component {
  state = {
    event: null,
    colors: null,
    loading: true,
    error: false,
    error_message: "",
  };

  vh = window.innerHeight * 0.01;

  async componentDidMount() {
    this.setVHValue();
    window.addEventListener("resize", this.setVHValue);

    try {
      this.setState({ loading: true });
      const event = await getEventByUrl(this.props.params.unique_str);
      const colors = await getEventColors(event.id);

      this.setState({
        event,
        colors,
        loading: false,
      });
    } catch (error) {
      let error_message = "";
      if (error.response && error.response.data) {
        error_message = error.response.data.detail;
      } else {
        error_message = error.message || "An error occurred";
      }
      this.setState({
        error: true,
        error_message,
        loading: false,
      });
    }
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.setVHValue);
  }

  setVHValue = () => {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", `${vh}px`);
  };

  handleContinue = async () => {
    // Get the unique_user_link from the navigation state
    const stateData = this.props.location.state || {};

    try {
      // Navigate to the next step based on the original logic
      if (this.state.event.with_presenter) {
        // Si c'est avec présentateur, aller vers la page Voter pour entrer le username
        if (stateData.unique_user_link) {
          this.props.navigate(
            "/events/" +
              this.props.params.unique_str +
              "/voter/" +
              stateData.unique_user_link
          );
        } else {
          this.props.navigate(
            "/events/" + this.props.params.unique_str + "/voter"
          );
        }
      } else {
        // Si c'est sans présentateur, vérifier le placement du questionnaire
        const baseQuestionnairePlacement = this.state.event.base_questionnaire_placement || "start";

        if (baseQuestionnairePlacement === "end") {
          // Questionnaire à la fin, aller directement vers la session
          if (stateData.unique_user_link) {
            await authVoter(
              this.state.event.id,
              "",
              stateData.unique_user_link
            );
          }
          this.props.navigate(
            "/events/" + this.props.params.unique_str + "/voter/session"
          );
        } else if (stateData.unique_user_link) {
          // Vérifier si le voter a déjà répondu aux questions obligatoires
          const answersOk = await getVoterByLink(
            this.state.event.id,
            stateData.unique_user_link
          );

          if (answersOk.questions_mandatory) {
            // Le voter a déjà répondu aux questions, aller directement vers la session
            await authVoter(
              this.state.event.id,
              "", // username vide car pas besoin pour un non-présentateur
              stateData.unique_user_link
            );
            this.props.navigate(
              "/events/" + this.props.params.unique_str + "/voter/session"
            );
          } else {
            // Le voter n'a pas encore répondu aux questions, aller vers register (pre-filter)
            this.props.navigate(
              "/events/" + this.props.params.unique_str + "/voter/register",
              {
                state: {
                  event_id: this.state.event.id,
                  langage: this.state.event.langage,
                  form_placement: this.state.event.form_placement,
                  base_questionnaire_placement: baseQuestionnairePlacement,
                  position: "start",
                  unique_link: stateData.unique_user_link,
                  event_refused_message: this.state.event.event_refused_message,
                  with_presenter: this.state.event.with_presenter,
                  unique_str: this.props.params.unique_str,
                  legal_notice: this.state.event.legal_notice,
                  post_filter_questionnaire_enabled: this.state.event.post_filter_questionnaire_enabled,
                  questionnaire_type: "filter",
                },
              }
            );
          }
        } else {
          // No unique_user_link, aller directement vers session
          this.props.navigate(
            "/events/" + this.props.params.unique_str + "/voter/session"
          );
        }
      }
    } catch (error) {
      // En cas d'erreur, suivre le flux normal - go to pre-filter if at start
      console.error("Error checking voter questions:", error);
      const baseQuestionnairePlacement = this.state.event.base_questionnaire_placement || "start";

      if (baseQuestionnairePlacement === "end") {
        // Questionnaire à la fin, aller vers la session
        this.props.navigate(
          "/events/" + this.props.params.unique_str + "/voter/session"
        );
      } else {
        this.props.navigate(
          "/events/" + this.props.params.unique_str + "/voter/register",
          {
            state: {
              event_id: this.state.event.id,
              langage: this.state.event.langage,
              form_placement: this.state.event.form_placement,
              base_questionnaire_placement: baseQuestionnairePlacement,
              position: "start",
              unique_link: stateData.unique_user_link,
              event_refused_message: this.state.event.event_refused_message,
              with_presenter: this.state.event.with_presenter,
              unique_str: this.props.params.unique_str,
              legal_notice: this.state.event.legal_notice,
              post_filter_questionnaire_enabled: this.state.event.post_filter_questionnaire_enabled,
              questionnaire_type: "filter",
            },
          }
        );
      }
    }
  };

  render() {
    const { event, colors, loading, error, error_message } = this.state;

    const lang = event?.langage;
    const translations = {
      continue: lang === "fr" ? "Continuer" : "Continue",
      error: lang === "fr" ? "Erreur" : "Error",
      close: lang === "fr" ? "Fermer" : "Close",
    };

    if (loading) {
      return (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            minHeight: "calc(var(--vh, 1vh) * 100)",
            backgroundColor: colors?.background_color,
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Spinner animation="border" variant="primary" />
        </div>
      );
    }

    if (error) {
      return (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            minHeight: "calc(var(--vh, 1vh) * 100)",
            backgroundColor: colors?.background_color,
          }}
        >
          <VoterNavBar
            text={event?.event_title}
            backgroundColor={colors?.header_background_color}
            img={BASE_URL + "/events/" + event?.id + "/data/logo"}
          />
          <Container
            style={{ maxWidth: "800px" }}
            fluid
            className="px-3 pt-3 flex-grow-1 d-flex flex-column justify-content-center"
          >
            <Alert variant="danger">
              <Alert.Heading>{translations.error}</Alert.Heading>
              <p>{error_message}</p>
            </Alert>
          </Container>
        </div>
      );
    }

    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          minHeight: "calc(var(--vh, 1vh) * 100)",
          position: "relative",
          paddingBottom: "54px",
          backgroundColor: colors?.background_color,
          overflowX: "hidden",
        }}
      >
        {/* Footer image */}
        {event && (
          <img
            src={BASE_URL + "/events/" + event.id + "/data/voter_footer"}
            style={{
              position: "absolute",
              bottom: 0,
              left: "50%",
              transform: "translateX(-50%)",
              height: "54px",
              objectFit: "fill",
            }}
            onError={(e) => {
              e.target.onerror = null;
              e.target.style.display = "none";
            }}
          />
        )}

        {/* Header */}
        {event && (
          <VoterNavBar
            text={event.event_title}
            backgroundColor={colors?.header_background_color}
            img={BASE_URL + "/events/" + event.id + "/data/logo"}
          />
        )}

        {/* Main content */}
        <Container
          style={{ maxWidth: "800px" }}
          fluid
          className="px-3 pt-3 flex-grow-1 d-flex flex-column"
        >
          <div
            style={{
              display: "flex",
              flex: 1,
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {/* First message display - same design as finished section in VoterSession */}
            <div
              className="p-3 mb-4"
              style={{
                display: "flex",
                width: "100%",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "15px",
                backgroundColor: colors?.statement_background_color,
              }}
            >
              {event.first_message && (
                <span
                  className="text-light"
                  style={{
                    fontSize: "1.5em",
                  }}
                  dangerouslySetInnerHTML={{
                    __html: event.first_message,
                  }}
                />
              )}
            </div>

            {/* Continue button */}
            <div
              style={{
                display: "flex",
                width: "100%",
                justifyContent: "center",
                alignItems: "center",
                marginTop: "20px",
              }}
            >
              <LoadingButton
                variant="dark"
                size="lg"
                onClick={this.handleContinue}
              >
                {translations.continue}
              </LoadingButton>
            </div>
          </div>

          {/* Legal notice */}
          {event && event.legal_notice && (
            <div
              className="text-center mb-2"
              style={{
                fontSize: "0.8rem",
                color: colors?.text_color || "#666",
              }}
            >
              {event.legal_notice}
            </div>
          )}
        </Container>
      </div>
    );
  }
}

export default withRouter(withTheme(VoterIntro));
